import classNames from 'classnames';
import React, {ReactNode} from 'react';

interface IProps {
  label: ReactNode;
  size?: 'xsmall' | 'small' | 'large';
  category?: 'primary' | 'secondary' | 'danger';
  backgroundColor?: string;
  color?: string;
  onClick?: () => void;
}

const COLORS: Record<Exclude<IProps['category'], undefined>, string> = {
  primary: 'bg-blue-100 text-blue-700',
  secondary: 'bg-gray-100 text-gray-700',
  danger: 'bg-red-100 text-red-700',
};
const SIZE: Record<Exclude<IProps['size'], undefined>, string> = {
  xsmall: 'text-xs px-1 py-0.5',
  small: 'text-xs px-2 py-1',
  large: 'text-sm px-2 py-1',
};

export const Badge: React.FC<IProps> = (props) => {
  const {label, size = 'small', category = 'primary', onClick} = props;
  return (
    <span
      className={classNames(
        'inline-flex items-center rounded-md font-medium',
        COLORS[category],
        SIZE[size],
      )}
      style={{
        ...(props.backgroundColor
          ? {backgroundColor: props.backgroundColor}
          : {}),
        ...(props.color ? {color: props.color} : {}),
      }}
      onClick={onClick}>
      {label}
    </span>
  );
};
